import { defineAppConfig } from "#imports";
const env = import.meta.env.NODE_ENV === 'production' ? 'prod' : 'staging'

export default defineAppConfig({
  seo: {
    url: import.meta.env.NUXT_APP_URL,
    defaultTitle: 'ArtNight',
    titleFormat: '{title} - ArtNight',
    titleHostFormat: 'Buche spannende Malkurse mit {host} | ArtNight',
    descriptionHostFormat:
      'Male angeleitet von {host} Schritt für Schritt in angesagten Locations deiner Stadt dein individuelles Kunstwerk.',
    venueTitle: 'Buche spannende Malkurse mit ArtNight – {venue}',
    descriptionVenueFormat: 'Malkurse mit dem gewissen Etwas - Erlebe ein tolles Event bei Bier, Wein oder etwas Anderem - {venue}',
    headTitle: 'ArtNight: Dein Erlebnis. Dein Kunstwerk.',
    headDescription:
      'ArtNight ist DAS kreative Erlebnis! Erlebe unterhaltsame Workshops unter der Leitung unserer ArtNight Künstler.',
    sitemap: {
      content:
        `https://artnight-sylius-${env}.fra1.digitaloceanspaces.com/sitemap/artnight_germany_content_sitemap.xml`,
      events: `https://artnight-sylius-${env}.fra1.digitaloceanspaces.com/sitemap/artnight_germany_events_sitemap.xml`,
      index: `https://artnight-sylius-${env}.fra1.digitaloceanspaces.com/sitemap/artnight_germany_index_sitemap.xml`
    }
  },
  theme: {
    brand: 'artnight',
    vertical: 'AN',
    channel: 'artnight-germany',
    color: '#6e0afa',
    email: 'mail@artnight.com',
    trustpilot_url: 'https://de.trustpilot.com/review/www.artnight.com',
    support_url: 'https://help.artnight.com/hc/de/requests/new',
    rebooking_help_url:
      'https://help.artnight.com/hc/de/articles/12541758923548-Kann-ich-mein-e-ArtNight-Ticket-s-stornieren',
  },
  trustpilot: {
    widget_script: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
  },
  timeZone: 'Europe/Berlin',
  url_map: {
    terms_and_conditions: '/agb/'
  },
  sentry: {
    tracing: true,
    trackComponents: true,
    tracesSampleRate: 0.01,
    environment: import.meta.env.NODE_ENV === "production" ? "production" : 'staging',
    logErrors: false,
    debug: false
  },
  company: 'Realtainment GmbH',
  rebooking_hour_limit: 48,
  group_events: {
    partner_location_cost: 10000,
    wish_motiv_cost: 35000,
    wish_motiv_code: 'wunschmotiv',
  }
});
